import React, { useState } from 'react';
import './branch.css';

interface LogoTileProps {
  src?: string;
  /** Brand name, for the monogram fallback. The tile itself is decorative (the name is the heading). */
  name: string;
}

/** The brand logo as an app icon: rounded square, soft shadow; a monogram when there is no logo. */
const LogoTile: React.FC<LogoTileProps> = ({ src, name }) => {
  const [failed, setFailed] = useState(false);
  return (
    <span className="logo-tile" aria-hidden="true">
      {src && !failed ? (
        <img className="logo-tile__img" src={src} alt="" onError={() => setFailed(true)} />
      ) : (
        <span className="logo-tile__monogram">{name.trim().charAt(0).toUpperCase()}</span>
      )}
    </span>
  );
};

export default LogoTile;
